/**
 * PDP Mobile Reorder
 * On mobile (≤749px) physically moves .product__price to be
 * immediately before .product__purchase-wrapper inside .product__info-container.
 * On desktop (>749px) restores .product__price to its original DOM position.
 */
(function () {
  var originalNextSibling = null; // element that was after .product__price at page load
  var initialized = false;

  function reorderPdpBlocks() {
    var container = document.querySelector('.product__info-container');
    if (!container) return;

    var price = container.querySelector('.product__price');
    var purchase = container.querySelector('.product__purchase-wrapper');
    if (!price) return;

    // Capture original position once, before any move
    if (!initialized) {
      originalNextSibling = price.nextElementSibling;
      initialized = true;
    }

    if (window.innerWidth <= 749) {
      // Move .product__price immediately before .product__purchase-wrapper
      if (purchase && purchase.previousElementSibling !== price) {
        container.insertBefore(price, purchase);
      }
    } else {
      // Restore .product__price to its original position
      if (originalNextSibling) {
        if (price.nextElementSibling !== originalNextSibling) {
          container.insertBefore(price, originalNextSibling);
        }
      } else {
        // It was the last child originally
        if (price !== container.lastElementChild) {
          container.appendChild(price);
        }
      }
    }
  }

  // Run once the DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reorderPdpBlocks);
  } else {
    reorderPdpBlocks();
  }

  // Re-run on resize in case the viewport crosses the 749px breakpoint
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(reorderPdpBlocks, 100);
  });
})();
